import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Spin } from 'antd';
import L from 'leaflet';

import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';
import { generarCapaBase } from '../commons/mapa';
import { seleccioObservacio } from '../../actions/index';
import obtenirObservacionsFiltradesPerPeriodeSelector from '../../selectors/selector_periode_observacio';
import { buscarPeriode } from '../commons/periodes';
import { variablesObservacions } from '../commons/paletesColors';
import { variables } from '../commons/variables';

import ObservacioMapaLlegenda from './observacioMapaLlegenda';

const idVariableCarregadaPerDefecte = 45;
const nomCapaVent = 'Velocitat i direcció del vent';

var VentIcon = L.DivIcon.extend({
	direccioVent: {
		N: 0,
		NNE: 22.5,
		NE: 45,
		ENE: 67.5,
		E: 90,
		ESE: 112.5,
		SE: 135,
		SSE: 157.5,
		S: 180,
		SSW: 202.5,
		SW: 225,
		WSW: 247.5,
		W: 270,
		WNW: 292.5,
		NW: 315,
		NNW: 337.5,
		CAL: 0
	},

	options: {
		iconAnchor: variablesObservacions['Vent'].iconAnchor,
		className: ''
	},

	initialize: function(options) {
		L.Util.setOptions(this, options);
		this._crearIconaPelVent();
	},

	_crearIconaPelVent: function() {
		var direccioVentEngraus = this.direccioVent[this.options.grausAsText];

		var imatgeVentAsText = '<img class="observacions-mapa-icona-vent" style="'
			.concat('transform: rotate(' + direccioVentEngraus + 'deg)" ')
			.concat('src="' + this.options.iconaURL + '"')
			.concat('>');
		this.options.html = imatgeVentAsText;
	}
});

/**
 * Retorna true si la variable es repreenta en forma de icona.
 *
 * @param variable
 * @returns {string|boolean}
 */
const esVariableTipusIcona = (variable) => variable.tipus === 'icona';

/**
 * Crea un objecte de tipus L.Icon. Depenent del tipus de representació de la variable, el objecte icon serà una icona
 * o un valor.
 *
 * @param variableObservacio
 * @param valor
 * @returns {L.Icon}
 */
const crearObjecteIcon = (variableObservacio, valor) => {
	let icon;

	const paleta = variableObservacio.paleta;

	const item = calcularColorDeMarcador(valor, paleta);

	if (!item) return;
	// Segons la paleta el valor es representara amb icona o amb valor i color.
	if (esVariableTipusIcona(variableObservacio)) {
		icon = L.icon({
			iconUrl: item.iconaURL,
			iconSize: variableObservacio.iconSize || {},
			iconAnchor: variableObservacio.iconAnchor || {}
		});
	} else {
		//Generar marcador amb valor i color
		var color = 'rgb(' + item.colorRGB[0] + ',' + item.colorRGB[1] + ',' + item.colorRGB[2] + ')';

		const etiquetaHTML = '<div class="observacio-mapa-icona-color" style="background-color: '.concat(color, '">', valor, '</div>');
		icon = L.divIcon({ className: '', html: etiquetaHTML });
	}

	return icon;
};

const crearLatLngPerEstacio = (estacio) => {
	const latitud = estacio.coordenades.latitud;
	const longitud = estacio.coordenades.longitud;

	return L.latLng(latitud, longitud);
};

/**
 * Retorna els valors de la variable que es mostra actualment al mapa
 */
const obtenirValorsObservacionsCapaActiva = (mapa) => {
	let valors = [];

	mapa.eachLayer(function(layer) {
		if (layer instanceof L.Marker) {
			valors.push(layer.options.valor);
		}
	});

	return valors;
};

/**
 * Retorna la paleta de colors corresponent a la variable seleccionada
 * dins dels llindars dels valors que es mostren al mapa (valors compresos
 * de les observacions vigents).
 * Si no hi ha observacions es mostra tota la gamma de colors.
 */
const obtenirPaletaDeColorsFiltrada = (paleta, valors) => {
	const limits = calcularValorMaximMinim(valors);

	//En cas que no s'han trobat limits perque no hi ha valors, s'ha rebut null i es mostrarà tota la paleta.
	if (!limits) {
		return;
	}

	//S'agafa només el tros de la paleta que es pintara depenent del limit superior i inferior
	var inici = paleta.findIndex((element) => {
		return element.condicions[1] > limits.inferior;
	});
	var fi = paleta.findIndex((element) => {
		return element.condicions[0] >= limits.superior;
	});

	//Si el limite superior esta por encima del maximo valor que hay en la paleta, se coge el ultimo valor de la paleta.
	if (fi === -1) {
		fi = paleta.length;
	}

	return paleta.slice(inici, fi + 1);
};

/**
 * El calcula el valor màxim i el valor mínim de la capa activa del mapa especificat per parametre
 *
 *  Si l'array es buit retorna un null
 * @param mapa
 * @returns {{inferior: *, superior: *}}
 */
const calcularValorMaximMinim = (valors) => {
	let limits;

	//sort() por defecto hace la oprdenación alfabeticamente(40 --> forty, 5 --> five), cuando son números puede que no lo haga bien.
	// Por eso se le pasa la función de ordenación
	valors.sort((currentElement, nextElement) => {
		return currentElement - nextElement;
	});

	if (valors.length > 0) {
		limits = {
			inferior: valors[0],
			superior: valors[valors.length - 1]
		};
	}

	return limits;
};

/**
 * S'obte de la paleta l'element associat al valor especificat per parametre. La associació es fa utilitzant l'atribut
 * condicions dels elements de la paleta. L'atribut condicions pot ser un array(amb dos posicions) o un numero.
 * En cas de ser un array el valor haurà de estar entre els dos valors del array.Això es aixi perque hi han variables que
 * tenen una paleta categoritzada i d'altres que no.
 *
 * @param paleta {Array}
 * @param valor
 * @returns {*} element de la paleta
 */
const obtenirElementDePaleta = (paleta, valor) => {
	if (!paleta[0]) {
		//No hi ha valors a la paleta
		return null;
	}

	var primerElement = paleta[0].condicions;

	var cercaDelElementSegonsCondicio;
	//es tria la funció que farà la cerca del valor dintre de la paleta
	if (Array.isArray(primerElement)) {
		cercaDelElementSegonsCondicio = (item) => valor >= item.condicions[0] && valor < item.condicions[1];
	} else {
		cercaDelElementSegonsCondicio = (item) => {
			//es possible que els valors numerics vinguin com Strings
			//valor = isNaN(valor) ? valor : parseInt(valor, 0);
			return valor === item.condicions;
		};
	}

	return paleta.find(cercaDelElementSegonsCondicio);
};

/**
 * Calculem color del marker tenint en compte que cada variable té la seva paleta definida.
 *
 * @param {type} valor
 * @param {type} variable
 * @returns {String} color en rgb
 */
const calcularColorDeMarcador = (valor, paleta) => {
	return obtenirElementDePaleta(paleta, valor);
};

/**
 * Genera un string amb el HTML que es possa al panell del mapa quan es passa el ratoli per sobre d'una estació.
 * @param estacio
 * @returns {string}
 */
const generaHTMLPerPanellInformacio = (estacio) => {
	return '<b>Codi estació: '.concat('</b>', estacio.codi, '<br />', '<b>Nom estació: ', '</b>', estacio.nom, '<br />', '<b>Comarca: ', '</b>', estacio.comarca, '<br />', '<b>Municipi: ', '</b>', estacio.municipi, '<br />');
};

/**
 * Recupera el valor de la velocitat del vent.
 * @param periode
 * @returns {{direccio: *, velocitat: *}}
 */
const obtenirValorVent = (periode, dadesVent) => {
	const valorVelocitatDelVent = obtenirComponentDeVent(variables[83].nom, periode, dadesVent); //'Velocitat del vent'
	const valorDireccioDelVent = obtenirComponentDeVent(variables[18].nom, periode, dadesVent); //'Direcció del vent'

	return {
		direccio: valorDireccioDelVent,
		velocitat: valorVelocitatDelVent
	};
};

/**
 * Recupera el valor de la component especificada per paràmetre(direccio o velocitat), per un periode
 * concret.
 *
 * @param nomComponent {String} pot ser 'Velocitat del vent' o 'Direcció del vent'
 * @param periode {String} pot tenir els valors '7h', '13h', '18h'
 * @returns {*}
 */
const obtenirComponentDeVent = (nomComponent, periode, dadesVent) => {
	//Busquem la variable correcte.
	var componentVent = dadesVent.variables.find((variable) => {
		return variable.nom === nomComponent;
	});

	if (!componentVent) return null;

	let momentsVent = componentVent.moments;

	//Es busca el periode concret
	let momentValorVent = momentsVent.find((moment) => {
		return moment.nom === periode;
	});

	return momentValorVent ? momentValorVent.valors[0] : null;
};

/**
 * Retorna un objecte que tindrà com index el nom de les variables i com valor un objecte amb la capa de leaflet.
 * @param {object} plantillaDeCapes
 */
const crearCapesLeafletPerControl = (plantillaDeCapes) => {
	let capesVariables = {};
	Object.keys(plantillaDeCapes).forEach((key) => {
		const capaLeaflet = plantillaDeCapes[key];

		capesVariables[capaLeaflet.nomVariable] = capaLeaflet;
	});

	return capesVariables;
};

const variablesPelMapa = {
	1: {
		nom: variables[1].nom,
		paleta: 'Temperatura',
		ordre: 1
	},
	4: {
		nom: variables[4].nom,
		paleta: 'Temperatura',
		ordre: 3
	},
	6: {
		nom: variables[6].nom,
		paleta: 'Temperatura',
		ordre: 4
	},
	3: {
		nom: variables[3].nom,
		paleta: 'Humitat relativa',
		ordre: 2
	},
	34: {
		nom: variables[34].nom,
		paleta: 'Precipitacio',
		ordre: 5
	},
	45: {
		nom: variables[45].nom,
		paleta: 'Coberta',
		ordre: 6
	},
	49: {
		nom: variables[49].nom,
		paleta: 'Visibilitat',
		ordre: 10
	},
	51: {
		nom: variables[51].nom,
		paleta: 'Mar',
		ordre: 11
	},
	41: {
		nom: variables[41].nom,
		paleta: 'Neu',
		ordre: 7
	},
	82: {
		nom: variables[82].nom,
		paleta: 'Neu',
		ordre: 8
	}
};

//per ordenar les capes segons el paràmetre ordre
const ordenarCapesSegonsOrdre = (layerA, layerB) => {
	if (layerA.ordre > layerB.ordre) {
		return 1;
	}
	if (layerA.ordre < layerB.ordre) {
		return -1;
	}
	// ordre layerA igual a ordre layerB
	return 0;
};

class ObservacioMapa extends Component {
	constructor(props) {
		super(props);
		this.mapa = null;
		this.plantillaDeCapes = this.crearPlantillaDeCapes();

		this.state = {
			nomCapaActiva: null
		};
	}

	actualitzarNomCapaActiva() {
		const nomCapaActiva = this.obtenirNomCapaActiva() || null;
		this.setState({ ...this.state, nomCapaActiva });
	}

	componentDidMount() {
		const ampladaPantalla = window.innerWidth;
		const nivellZoom = ampladaPantalla < 600 ? 7 : 8;

		//Crear el objecte que se li passara al control de capes leaflet
		this.capesVariables = crearCapesLeafletPerControl(this.plantillaDeCapes);

		const nomCapaPerDefecte = variablesPelMapa[idVariableCarregadaPerDefecte].nom;
		var layer = generarCapaBase();
		this.mapa = L.map(this.container, {
			maxZoom: 13,
			minZoom: nivellZoom,
			zoom: nivellZoom,
			maxBounds: [[43, -0.06], [40.37, 3.57]],
			center: [41.69, 1.76],
			layers: [layer, this.capesVariables[nomCapaPerDefecte]], //capes carregades per defecte
			attributionControl: false
		});

		const options = {
			sortLayers: true,
			sortFunction: ordenarCapesSegonsOrdre
		};

		//Control de capes de Leaflet (seleccionar la capa de fons i la capa de la variable)
		const leafletControlLayers = L.control.layers(this.capesVariables, null, options).addTo(this.mapa);

		this.mapa.on('baselayerchange', () => {
			this.actualitzarNomCapaActiva();
			leafletControlLayers.collapse();
		});

		//Panell que mostra la informació d'una estació
		this.panellInformacio = this.crearPanellInformacio();
		//Panell informació estació s'afegeix al mapa
		this.panellInformacio.addTo(this.mapa);

		//Es crean les capes que tene valor pel periode seleccionat i s'afegeixen al mapa
		this.omplirCapesValorVariables(this.props.observacions, this.props.periodeSeleccionat, this.capesVariables, variables);
	}

	componentWillUnmount() {
		//Quan es destruexi el component, s'ha d'eliminar el mapa de leaflet
		this.mapa.remove();
	}

	componentWillReceiveProps(novesPropietats) {
		//S'executa cada cop que es modifiquen les propietats del component. En aquest cas cada cop que es modifiquen
		//les observacions filtrades pel periode
		this.netejarCapes();
		this.omplirCapesValorVariables(novesPropietats.observacions, novesPropietats.periodeSeleccionat, this.capesVariables, variables);
		this.actualitzarNomCapaActiva();
	}

	crearPlantillaDeCapes() {
		const plantillaDeCapes = {};

		Object.keys(variablesPelMapa).forEach((idVariable) => {
			const metaVariable = variablesPelMapa[idVariable];

			const options = {
				nomVariable: metaVariable.nom,
				nomPaleta: metaVariable.paleta,
				idVariable: Number(idVariable),
				ordre: metaVariable.ordre
			};

			plantillaDeCapes[idVariable] = this.crearCapa(options);
		});

		//Afegim la variable vent que es un cas especial
		const optionsVent = {
			nomVariable: nomCapaVent,
			nomPaleta: 'Vent',
			ordre: 9
		};
		plantillaDeCapes[nomCapaVent] = this.crearCapa(optionsVent);

		return plantillaDeCapes;
	}

	/**
	 * Retorna el nom de la capa que esta activa(que se esta visualitzant)
	 * @returns {String} nom de la capa
	 */
	obtenirNomCapaActiva() {
		let nomCapaActiva = Object.keys(this.capesVariables).find((key) => {
			var capaLeaflet = this.capesVariables[key];
			return this.mapa.hasLayer(capaLeaflet);
		});

		return nomCapaActiva;
	}

	/**
	 * Crea el panell que mostra la informació de l'estació
	 */
	crearPanellInformacio() {
		let panellInformacio = L.control({ position: 'bottomright' });

		panellInformacio.onAdd = function() {
			this._div = L.DomUtil.create('div', 'observacio-mapa-panell-informacio');
			this.update();
			return this._div;
		};

		panellInformacio.update = function(estacio) {
			this._div.innerHTML = estacio ? generaHTMLPerPanellInformacio(estacio) : 'Selecciona una estació';
		};

		return panellInformacio;
	}

	/**
	 * Crea una nova capa Leaflet. El parametre llegenda conté el nom de la paleta de colors que ha d'utilitzar la capa
	 * per renderitzarse per pantalla.
	 *
	 * @param llegenda
	 * @returns {*}
	 */
	crearCapa(llegenda) {
		var capa = L.featureGroup()
			.on('click', this.onClick.bind(this))
			.on('mouseover', this.onMouseOver.bind(this))
			.on('mouseout', this.onMouseOut.bind(this));

		Object.assign(capa, llegenda);

		return capa;
	}

	/**
	 * S'eliminen tots els marcadors de cadasquna de les capes que s'han creat al component.
	 */
	netejarCapes() {
		for (var variable in this.capesVariables) {
			if (this.capesVariables[variable]) {
				this.capesVariables[variable].clearLayers();
			}
		}
	}

	omplirCapesValorVariables(observacions, periodeSeleccionat, capesVariables, variables) {
		observacions.forEach((observacio) => {
			observacio.grupsVariables.forEach((grupVariable) => {
				if (grupVariable.grup === 'Vent') {
					try {
						this.afegirValorPeriodeACapaDeVent(periodeSeleccionat, grupVariable, observacio);
					} catch (error) {
						console.error('No s\'han pogut carregar les imatges de la capa "Vent": ', error.message);
					}
				} else {
					grupVariable.variables.forEach((variable) => {
						const nomVariable = variables[variable.id] ? variables[variable.id].nom : null;

						if (nomVariable) {
							const capa = capesVariables[nomVariable];
							this.afegirValorPeriodeVariableACapa(capa, variable, periodeSeleccionat, observacio);
						}
					});
				}
			});
		});
	}

	/**
	 * Omple la capa de vent amb els valors de les variables direccio i velocitat del vent. Els valors fan
	 * referencia al periode especificat per parametre.
	 * Els valors s'afegeixen a la capa especificada per parametre, que ha de ser la de vent
	 *
	 * @param periodeSeleccionat
	 * @param grupVariable
	 * @param observacio
	 */
	afegirValorPeriodeACapaDeVent(periodeSeleccionat, grupVariable, observacio) {
		const capaVent = this.capesVariables[nomCapaVent];

		if (!capaVent) return;

		const valorVent = obtenirValorVent(periodeSeleccionat, grupVariable);
		const estacio = observacio.estacio;

		const latlngDeEstacio = crearLatLngPerEstacio(estacio);

		const paleta = variablesObservacions[capaVent.nomPaleta].paleta;

		//S'ha de mostar només si les dues variables del vent estan informades.
		if (valorVent.direccio && valorVent.velocitat !== null) {
			const item = calcularColorDeMarcador(valorVent.velocitat, paleta);

			const direccioVent = item ? valorVent.direccio : 0;
			const iconaVent = item ? item.iconaURL : paleta[13].iconaURL;

			const icona = new VentIcon({
				grausAsText: direccioVent,
				iconaURL: iconaVent
			});

			var marker = L.marker(latlngDeEstacio, {
				icon: icona,
				id: observacio.estacio.codi,
				valor: valorVent
			});

			marker.addTo(capaVent);
		}
	}

	/**
	 * Per una capa concreta es crea i s'afegeix un marcador, amb el valor de la variable.
	 *
	 * @param capesVariables {Object}
	 * @param variable {Object}
	 * @param periodeSeleccionat {String}
	 * @param observacio {Object}
	 */
	afegirValorPeriodeVariableACapa(capa, variable, periodeSeleccionat, observacio) {
		const nomPaleta = capa.nomPaleta;

		variable.moments.forEach((moment) => {
			let nomMoment = buscarPeriode(moment.nom);
			/*Pot existir més d'un valor en un moment i variable concrets.
             En principi les que es mostren al mapa no poden tenir múltiples valors,
             però en cas que passés es mostraria el primer valor.
             El valors poden ser strings o numbers. A la paleta els valors numerics son Numbers i els de tipus llista
             poden ser String, com per exemple la variable mar
             */
			var valorMostrarMapa = moment.valors[0];

			//Aquesta condicio, exclou els valors que tinguin valor null.
			if (nomMoment === periodeSeleccionat && valorMostrarMapa !== null && valorMostrarMapa !== '') {
				let marcadorValorVariable = this.crearMarcador(valorMostrarMapa, observacio, variable.nom, nomPaleta);
				//només s'afegueix si hi han marcador
				if (marcadorValorVariable) marcadorValorVariable.addTo(capa);
			}
		});
	}

	/**
	 * Es crea un marcador per un valor d'una variable. L'ubicació del marcador ve donada per les coordenadesde
	 * l'estació.
	 *
	 * @param valor {String}
	 * @param estacio {Object}
	 * @param idObservacio {int}
	 * @returns {*}
	 */
	crearMarcador(valor, observacio, nomVariable, nomPaletaColors) {
		const latlongDeEstacio = crearLatLngPerEstacio(observacio.estacio);

		let icon = crearObjecteIcon(variablesObservacions[nomPaletaColors], valor);
		//Si no ha pogut crear l'objecte icon no s'ha d'afegir al mapa.
		if (!icon) return;

		const marcadorValorVariable = L.marker(latlongDeEstacio, { icon: icon, id: observacio.estacio.codi, valor: valor });

		return marcadorValorVariable;
	}

	onClick(evt) {
		const codiEstacio = evt.layer.options.id;
		if (this.props.codiEstacio !== codiEstacio) {
			this.props.seleccioObservacio(codiEstacio);
		}
	}

	onMouseOver(event) {
		const codiEstacio = event.layer.options.id;

		var observacio = this.props.observacions.find((observacio) => {
			return observacio.estacio.codi === codiEstacio;
		});

		this.panellInformacio.update(observacio.estacio);
	}

	onMouseOut() {
		this.panellInformacio.update();
	}

	/**
	 * Genera un element <div> amb la llegenda de la capa especificada per parametre. La paleta de colors s'agafa a partir
	 * del nom de la capa del objecte {variablesObservacions}, d'aquest objecte s'obtenen els colors per tots els posibles valors.
	 *
	 * @param nomCapa {String} nom de la capa de la cual es vol crear la llegenda
	 */
	generarLlegenda(nomCapaActiva) {
		if (!nomCapaActiva) {
			return null;
		}

		const valorsCapaActiva = obtenirValorsObservacionsCapaActiva(this.mapa);

		if (valorsCapaActiva.length <= 0) {
			return null;
		}

		const nomPaletaColors = this.capesVariables[nomCapaActiva].nomPaleta;
		const paleta = variablesObservacions[nomPaletaColors].paleta;

		let paletaFiltrada;
		const esVariablesTipusIcona = esVariableTipusIcona(variablesObservacions[nomPaletaColors]);

		if (esVariablesTipusIcona) {
			paletaFiltrada = paleta;
		} else {
			//Es filtra la paleta amb els valors mínims i màxims
			paletaFiltrada = obtenirPaletaDeColorsFiltrada(paleta, valorsCapaActiva);
		}

		const idVariables = this.capesVariables[nomCapaActiva].idVariable;
		let titolLlegenda;

		//Cas especial del vent
		if (nomCapaActiva === nomCapaVent) {
			titolLlegenda = 'Velocitat i direcció del vent (Escala de Beaufort)';
		}

		//La variable velocitat i dirieccio del vent no hi estarà
		if (!titolLlegenda && variables[idVariables]) {
			const unitat = variables[idVariables].unitat;
			titolLlegenda = `${nomCapaActiva} (${unitat})`;
		}

		return <ObservacioMapaLlegenda paleta={paletaFiltrada} titolLlegenda={titolLlegenda} esDeTipusIcona={esVariablesTipusIcona} />;
	}

	render() {
		if (!this.props.observacions) {
			return <div>{"No s'ha pogut carregar el mapa d'observacions"}</div>;
		}

		const { nomCapaActiva } = this.state;

		let llegenda = this.generarLlegenda(nomCapaActiva);

		return (
			<div>
				<div className='observacio-mapa-mapa' ref={(ref) => (this.container = ref)}>
					<div>
						<Spin className='carregant' delay={RETARD_MILISEGONS_APARICIO_SPINNER} spinning={this.props.carregant} size='large'></Spin>
					</div>
				</div>

				<div className='observacio-mapa-llegenda'>{llegenda}</div>
			</div>
		);
	}
}

ObservacioMapa.propTypes = {
	observacions: PropTypes.array,
	carregant: PropTypes.bool,
	periodeSeleccionat: PropTypes.string,
	codiEstacio: PropTypes.string,
	seleccioObservacio: PropTypes.func
};

const mapStateToProps = (state) => ({
	//TODO el filtrado de observaciones se podria optimizar. Ahora mismo este metodo lo que hace es recuperar la observacion
	//entera cuando tiene informado algun periodo. En realidad no haria falta devolver la observación entera ya que solo se va ha mostar un único periodo.
	//Se podria devolver la observación directementen con valor para el period seleccionado
	observacions: obtenirObservacionsFiltradesPerPeriodeSelector(state),
	codiEstacio: state.observacio.detall,
	periodeSeleccionat: state.observacio.periodeSeleccionat,
	carregant: state.observacio.totes.carregant
});

export default connect(
	mapStateToProps,
	{ seleccioObservacio }
)(ObservacioMapa);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioMapa.js